export const homeModuleKeyList = [
  'joinGroup',
  'notice',
  'userSetting',
  'mall',
  'blackMarket',
  'commerce',
  'warehouse',
  'smithy',
  'institute',
  'equipHandbook',
  'treasury',
  'pub',
  'occultScience',
  'darkGoldWorkshop',
  'rank',
  'supremeWorkshop',
  'magicWorkshop',
  'noviceCheckIn',
  'petRanch',
  'awaken',
  'secondAwaken',
  'relic',
  'activityCheckIn',
  'activityCelebration',
  'testServerCdkeyDraw',
] as const

export type HomeModuleKey = (typeof homeModuleKeyList)[number]

export type HomeModuleConfigItem = {
  show: boolean
  span: 1 | 2 | 3
}

export type HomeModuleConfigType = Record<HomeModuleKey, HomeModuleConfigItem>
export type HomeModuleOrderType = HomeModuleKey[]

export type HomeModuleSettingType = {
  config: HomeModuleConfigType
  order: HomeModuleOrderType
}

export const homeModuleMetaList: { key: HomeModuleKey; label: string }[] = [
  { key: 'joinGroup', label: '加入官方群' },
  { key: 'notice', label: '公告栏' },
  { key: 'userSetting', label: '设置' },
  { key: 'mall', label: '商城' },
  { key: 'blackMarket', label: '黑市' },
  { key: 'commerce', label: '商会' },
  { key: 'warehouse', label: '仓库' },
  { key: 'smithy', label: '铁匠铺' },
  { key: 'institute', label: '研究所' },
  { key: 'equipHandbook', label: '图鉴' },
  { key: 'treasury', label: '持有道具' },
  { key: 'pub', label: '酒馆' },
  { key: 'occultScience', label: '秘术坊' },
  { key: 'darkGoldWorkshop', label: '暗金工坊' },
  { key: 'rank', label: '奇闻' },
  { key: 'supremeWorkshop', label: '至臻工坊' },
  { key: 'magicWorkshop', label: '魔法工坊' },
  { key: 'noviceCheckIn', label: '新手签到' },
  { key: 'petRanch', label: '魔物牧场' },
  { key: 'awaken', label: '觉醒殿堂' },
  { key: 'secondAwaken', label: '二觉殿堂' },
  { key: 'relic', label: '圣物藏馆' },
  { key: 'activityCheckIn', label: '元旦签到' },
  { key: 'activityCelebration', label: '新春庆典' },
  { key: 'testServerCdkeyDraw', label: '测试服资格抽取' },
]

export const defaultHomeModuleConfig: HomeModuleConfigType = {
  joinGroup: { show: true, span: 1 },
  notice: { show: true, span: 1 },
  userSetting: { show: true, span: 1 },
  mall: { show: true, span: 1 },
  blackMarket: { show: true, span: 1 },
  commerce: { show: true, span: 1 },
  warehouse: { show: true, span: 1 },
  smithy: { show: true, span: 1 },
  institute: { show: true, span: 1 },
  equipHandbook: { show: true, span: 1 },
  treasury: { show: true, span: 1 },
  pub: { show: true, span: 1 },
  occultScience: { show: true, span: 1 },
  darkGoldWorkshop: { show: true, span: 1 },
  rank: { show: true, span: 1 },
  supremeWorkshop: { show: true, span: 1 },
  magicWorkshop: { show: true, span: 2 },
  noviceCheckIn: { show: true, span: 3 },
  petRanch: { show: true, span: 3 },
  awaken: { show: true, span: 3 },
  secondAwaken: { show: true, span: 3 },
  relic: { show: true, span: 3 },
  activityCheckIn: { show: true, span: 3 },
  activityCelebration: { show: true, span: 3 },
  testServerCdkeyDraw: { show: true, span: 3 },
}

export const defaultHomeModuleOrder: HomeModuleOrderType = [...homeModuleKeyList]

export function normalizeHomeModuleConfig(config?: Partial<Record<HomeModuleKey, Partial<HomeModuleConfigItem>>> | null): HomeModuleConfigType {
  const result = JSON.parse(JSON.stringify(defaultHomeModuleConfig)) as HomeModuleConfigType
  if (!config) return result

  for (const key of homeModuleKeyList) {
    const current = config[key]
    if (!current) continue

    const span = Number(current.span)
    result[key] = {
      show: current.show === undefined ? result[key].show : Boolean(current.show),
      span: span >= 1 && span <= 3 ? (Math.floor(span) as 1 | 2 | 3) : result[key].span,
    }
  }

  return result
}

export function normalizeHomeModuleOrder(order?: HomeModuleKey[] | null): HomeModuleOrderType {
  if (!order || !Array.isArray(order)) return [...defaultHomeModuleOrder]

  const ordered = order.filter((item): item is HomeModuleKey => (homeModuleKeyList as readonly string[]).includes(item))
  const missing = homeModuleKeyList.filter((item) => !ordered.includes(item))

  return [...ordered, ...missing]
}

export function normalizeHomeModuleSetting(
  setting?: {
    config?: Partial<Record<HomeModuleKey, Partial<HomeModuleConfigItem>>> | null
    order?: HomeModuleKey[] | null
  } | null,
): HomeModuleSettingType {
  return {
    config: normalizeHomeModuleConfig(setting?.config),
    order: normalizeHomeModuleOrder(setting?.order),
  }
}
